// Validation patterns for various document numbers
export const validationPatterns = {
  // PAN validation pattern
  PAN: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
  
  // TAN validation pattern - comprehensive list of all TAN prefixes
  TAN: /^(HYD[A-Z][0-9]{5}[A-Z]|VPN[A-Z][0-9]{5}[A-Z]|BBN[A-Z][0-9]{5}[A-Z]|BPL[A-Z][0-9]{5}[A-Z]|JBP[A-Z][0-9]{5}[A-Z]|CHE[A-Z][0-9]{5}[A-Z]|CMB[A-Z][0-9]{5}[A-Z]|MRI[A-Z][0-9]{5}[A-Z]|DEL[A-Z][0-9]{5}[A-Z]|CAL[A-Z][0-9]{5}[A-Z]|MRT[A-Z][0-9]{5}[A-Z]|AHM[A-Z][0-9]{5}[A-Z]|BRD[A-Z][0-9]{5}[A-Z]|RKT[A-Z][0-9]{5}[A-Z]|SRT[A-Z][0-9]{5}[A-Z]|BLR[A-Z][0-9]{5}[A-Z]|AGR[A-Z][0-9]{5}[A-Z]|KNP[A-Z][0-9]{5}[A-Z]|CHN[A-Z][0-9]{5}[A-Z]|TVD[A-Z][0-9]{5}[A-Z]|ALD[A-Z][0-9]{5}[A-Z]|LKN[A-Z][0-9]{5}[A-Z]|MUM[A-Z][0-9]{5}[A-Z]|NGP[A-Z][0-9]{5}[A-Z]|AMR[A-Z][0-9]{5}[A-Z]|JLD[A-Z][0-9]{5}[A-Z]|PTL[A-Z][0-9]{5}[A-Z]|RTK[A-Z][0-9]{5}[A-Z]|KLP[A-Z][0-9]{5}[A-Z]|NSK[A-Z][0-9]{5}[A-Z]|PNE[A-Z][0-9]{5}[A-Z]|PTN[A-Z][0-9]{5}[A-Z]|RCH[A-Z][0-9]{5}[A-Z]|JDH[A-Z][0-9]{5}[A-Z]|JPR[A-Z][0-9]{5}[A-Z]|SHL[A-Z][0-9]{5}[A-Z])$/,
  
  // PIN code validation pattern
  PIN: /^[1-9]{1}[0-9]{5}$/,
  
  // PRAN validation pattern - Min & Max length 12
  PRAN: /^.{12,12}$/,
  
  // Aadhar card number validation pattern
  AADHAR: /^[0-9]{12}$/
};

// Validation functions
export const validateField = (fieldName, value) => {
  if (!value || !value.trim()) {
    return { isValid: true, errorMessage: "" }; // Empty values are valid (not required)
  }
  
  const trimmedValue = value.trim();
  
  switch (fieldName.toUpperCase()) {
    case 'PAN':
    case 'PANNO':
    case 'PANNUMBER':
      if (!validationPatterns.PAN.test(trimmedValue)) {
        return { isValid: false, errorMessage: "Invalid PAN format. Expected format: ABCDE1234F" };
      }
      break;
      
    case 'TAN':
    case 'TANNUMBER':
      if (!validationPatterns.TAN.test(trimmedValue)) {
        return { isValid: false, errorMessage: "Invalid TAN format. Expected format: DELA12345F" };
      }
      break;
      
    case 'PIN':
    case 'PINCODE':
    case 'PINCODE':
      if (!validationPatterns.PIN.test(trimmedValue)) {
        return { isValid: false, errorMessage: "Invalid PIN code format. Expected format: 123456" };
      }
      break;
      
    case 'PRAN':
    case 'PRANNUMBER':
      if (!validationPatterns.PRAN.test(trimmedValue)) {
        return { isValid: false, errorMessage: "PRAN number must be exactly 12 characters long" };
      }
      break;
      
    case 'AADHAR':
    case 'AADHAAR':
    case 'AADHAARNO':
    case 'AADHAARNUMBER':
      if (!validationPatterns.AADHAR.test(trimmedValue)) {
        return { isValid: false, errorMessage: "Invalid Aadhar number format. Expected format: 123456789012" };
      }
      break;
      
    default:
      return { isValid: true, errorMessage: "" };
  }
  
  return { isValid: true, errorMessage: "" };
};

// Function to validate multiple fields at once
export const validateFields = (fields) => {
  const errors = {};
  
  Object.keys(fields).forEach(fieldName => {
    const validation = validateField(fieldName, fields[fieldName]);
    if (!validation.isValid) {
      errors[fieldName] = validation.errorMessage;
    }
  });
  
  return errors;
};

// Function to check if a value matches any of the patterns
export const matchPattern = (value, patternType) => {
  if (!value || !value.trim()) return false;
  
  const trimmedValue = value.trim();
  
  switch (patternType.toUpperCase()) {
    case 'PAN':
      return validationPatterns.PAN.test(trimmedValue);
    case 'TAN':
      return validationPatterns.TAN.test(trimmedValue);
    case 'PIN':
      return validationPatterns.PIN.test(trimmedValue);
    case 'PRAN':
      return validationPatterns.PRAN.test(trimmedValue);
    case 'AADHAR':
      return validationPatterns.AADHAR.test(trimmedValue);
    default:
      return false;
  }
};

export default validationPatterns;
